
import { authApi, apiClienteGenerica } from "../../apis";
import Swal from "sweetalert2";



export const loginService = async (login) => {
    try {
        const { data } = await authApi.post('/login', login);
        return data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}


export const loginClienteService = async (login) => {
    try {
        const { data } = await authApi.post('/login/cliente', login);
        return data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}



export const checkStatus = async () => {
    try {
        const { data } = await authApi.get('/renew');
        return data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}



export const checkStatusCliente = async () => {
    try {
        const { data } = await apiClienteGenerica.get('auth/renew');
        return data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}



export const actualizarPassword = async (body) => {
    try {
        const { data } = await authApi.put('/cambio-clave', body);
        Swal.fire('Exitoso', data.msg, 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}  



export const resetPasswordAdmin = async (id) => {
    try {
        const { data } = await authApi.put(`/reset/password/${id}`);
        Swal.fire('Exitoso', `El nuevo password es: ${data.msg}`, 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}
